/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_No_State_LabelInputs */

const en_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No State`)
};

const fr_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans etat`)
};

const de_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Staat`)
};

const it_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno Stato`)
};

const ru_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет государства`)
};

const es_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin Estado`)
};

const zh_cn2_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无州`)
};

const ja_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`州なし`)
};

const hi_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई राज्य नहीं`)
};

const pt_pt2_explorer_kanban_no_state_label = /** @type {(inputs: Explorer_Kanban_No_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum estado`)
};

/**
* | output |
* | --- |
* | "No State" |
*
* @param {Explorer_Kanban_No_State_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_no_state_label = /** @type {((inputs?: Explorer_Kanban_No_State_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_No_State_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_no_state_label(inputs)
	if (locale === "de") return de_explorer_kanban_no_state_label(inputs)
	if (locale === "it") return it_explorer_kanban_no_state_label(inputs)
	if (locale === "ru") return ru_explorer_kanban_no_state_label(inputs)
	if (locale === "es") return es_explorer_kanban_no_state_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_no_state_label(inputs)
	if (locale === "ja") return ja_explorer_kanban_no_state_label(inputs)
	if (locale === "hi") return hi_explorer_kanban_no_state_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_no_state_label(inputs)
	return en_explorer_kanban_no_state_label(inputs)
});